import { Routes, Route, Navigate } from "react-router-dom";
import SignIn from "../pages/SignIn";
import ForgotPassword from "../pages/ForgotPassword";
import Dashboard from "../pages/Dashboard";
import SharedFolders from "../pages/SharedFolders";
import BrowseClients from "../pages/BrowseClients";
import CreateClients from "../pages/CreateClients";
import EditClient from "../pages/EditClient";
import { useAuth } from "../context/AuthContext";
import VerifyOtp from "../pages/VerifyOtp";
import FolderDetails from "../pages/FolderDetails";
import FavoritesFolders from "../pages/FavoritesFolders";
import PersonalFolders from "../pages/PersonalFolders";
import BrowseMessages from "../pages/BrowseMessages";
import EmailSettings from "../pages/EmailSettings";
import BrowseUsers from "../pages/BrowseUsers";
import PersonalSettings from "../pages/PersonalSettings";
import FileSettings from "../pages/FileSettings";
import ResetPassword from "../pages/ResetPassword";
import NotFoundPage from "../pages/NotFoundPage";

// ✅ Protects private routes (only accessible if user is authenticated)
const RoleBasedRoute = ({ allowedRoles, children }) => {
  const { user } = useAuth();

  if (!user) {
    return <Navigate to="/signin" replace />;
  }

  if (!allowedRoles.includes(user.user_type)) {
    // Redirect to a fallback or forbidden page if role is not allowed
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};


const PrivateRoute = ({ children }) => {
  const { user } = useAuth();
  return user ? children : <Navigate to="/signin" replace />;
};

// ✅ Prevents logged-in users from accessing SignIn (redirects to Dashboard)
const AuthRoute = ({ children }) => {
  const { user } = useAuth();
  return user ? <Navigate to="/dashboard" replace /> : children;
};

const AppRoutes = () => {
  const { user } = useAuth();
  console.log('user----->',user)
  return (
    // <Routes>
    //   {/* Public route (redirect if logged in) */}
    //   <Route path="/signin" element={<AuthRoute><SignIn /></AuthRoute>} />
    //   <Route path="/otp-auth" element={<AuthRoute><VerifyOtp /></AuthRoute>} />
    //     <Route path="/reset-password" element={<AuthRoute><ResetPassword /></AuthRoute>} />
    //   <Route path = "/forgot-password" element ={<AuthRoute><ForgotPassword /></AuthRoute>}/>
    //   {/* Private route (redirect if not logged in) */}
    //   <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
    //   <Route path="/browse-clients" element={<PrivateRoute><BrowseClients /></PrivateRoute>} />
    //   <Route path="/browse-users" element={<PrivateRoute><BrowseUsers /></PrivateRoute>} />
    //   <Route path="/create-clients" element={<PrivateRoute><CreateClients /></PrivateRoute>} />
    //   <Route path="/edit-client/:id" element={<PrivateRoute><EditClient /></PrivateRoute>} />
    //   <Route path="/shared-folders" element={<PrivateRoute><SharedFolders /></PrivateRoute>} />
    //   <Route path="/folder-details/*" element={<PrivateRoute><FolderDetails /></PrivateRoute>} />
    //   <Route path="/favorite-folders" element={<PrivateRoute><FavoritesFolders /></PrivateRoute>} />
    //   <Route path="/personal-folders" element={<PrivateRoute><PersonalFolders /></PrivateRoute>} />
    //   <Route path="/browse-messages" element={<PrivateRoute><BrowseMessages /></PrivateRoute>} />
    //   <Route path="/email-settings" element={<PrivateRoute><EmailSettings /></PrivateRoute>} />
    //   <Route path="/personal-settings" element={<PrivateRoute><PersonalSettings /></PrivateRoute>} />
    //   <Route path="/file-settings" element={<PrivateRoute><FileSettings /></PrivateRoute>} />
    //   <Route path = "/forgot-password" element ={<PrivateRoute><ForgotPassword /></PrivateRoute>}/>

    //   {/* Fallback route */}
    //   <Route path="*" element={<Navigate to="/signin" replace />} />
    // </Routes>
    <Routes>
  {/* Public routes */}
  <Route path="/signin" element={<AuthRoute><SignIn /></AuthRoute>} />
  <Route path="/otp-auth" element={<AuthRoute><VerifyOtp /></AuthRoute>} />
  <Route path="/reset-password" element={<AuthRoute><ResetPassword /></AuthRoute>} />
  <Route path="/forgot-password" element={<AuthRoute><ForgotPassword /></AuthRoute>} />

  {/* <Route
  path="/dashboard"
  element={<RoleBasedRoute allowedRoles={['CLIENT', 'ADMIN']}><Dashboard /></RoleBasedRoute>}
/> */}


  {/* CLIENT-ONLY routes */}
  {/* <Route
    path="/dashboard"
    element={<RoleBasedRoute allowedRoles={['CLIENT']}><Dashboard /></RoleBasedRoute>}
  /> */}
  {/* <Route
    path="/shared-folders"
    element={<RoleBasedRoute allowedRoles={['CLIENT']}><SharedFolders /></RoleBasedRoute>}
  /> */}
  {/* <Route
    path="/favorite-folders"
    element={<RoleBasedRoute allowedRoles={['CLIENT']}><FavoritesFolders /></RoleBasedRoute>}
  /> */}
  <Route
    path="/personal-settings"
    element={<RoleBasedRoute allowedRoles={['CLIENT']}><PersonalSettings /></RoleBasedRoute>}
  />

  {/* ADMIN-ONLY routes */}
  {/* <Route
    path="/dashboard"
    element={<RoleBasedRoute allowedRoles={['ADMIN']}><Dashboard /></RoleBasedRoute>}
  /> */}
  <Route
    path="/browse-clients"
    element={<RoleBasedRoute allowedRoles={['ADMIN']}><BrowseClients /></RoleBasedRoute>}
  />
  <Route
    path="/create-clients"
    element={<RoleBasedRoute allowedRoles={['ADMIN']}><CreateClients /></RoleBasedRoute>}
  />
  <Route
    path="/edit-client/:id"
    element={<RoleBasedRoute allowedRoles={['ADMIN']}><EditClient /></RoleBasedRoute>}
  />
  <Route
    path="/browse-users"
    element={<RoleBasedRoute allowedRoles={['ADMIN']}><BrowseUsers /></RoleBasedRoute>}
  />
  <Route
    path="/browse-messages"
    element={<RoleBasedRoute allowedRoles={['ADMIN']}><BrowseMessages /></RoleBasedRoute>}
  />
  <Route
    path="/email-settings"
    element={<RoleBasedRoute allowedRoles={['ADMIN']}><EmailSettings /></RoleBasedRoute>}
  />
  <Route
    path="/file-settings"
    element={<RoleBasedRoute allowedRoles={['ADMIN']}><FileSettings /></RoleBasedRoute>}
  />
  <Route
    path="/personal-folders"
    element={<RoleBasedRoute allowedRoles={['ADMIN']}><PersonalFolders /></RoleBasedRoute>}
  />

  {/* Shared between roles (Optional: adjust if needed) */}
  <Route
    path="/folder-details/*"
    element={<PrivateRoute><FolderDetails /></PrivateRoute>}
  />
  <Route 
  path="/dashboard" 
  element={<PrivateRoute><Dashboard /></PrivateRoute>} />
  <Route
    path="/shared-folders"
    element={<PrivateRoute><SharedFolders /></PrivateRoute>}
  />
  <Route
    path="/favorite-folders"
    element={<PrivateRoute><FavoritesFolders /></PrivateRoute>}
  />
  

  {/* Fallback route */}
  <Route path="/" element={<Navigate to="/signin" replace />} />
  <Route path="*" element={<NotFoundPage/>}/>
    </Routes>

  );
};

export default AppRoutes;
